<template>
    <el-dialog
        title="应付详情"
        :visible.sync="payableDetailsDialogVisible"
        width="800px"
        :before-close="handleDetailDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :modal-append-to-body="false"
        custom-class="custom-form-dialog custom-payable-detail_dialog"
    >
        <div class="page_little_title">基本信息</div>
        <el-form label-position="top" size="small">
            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="应付编号">
                        <div v-text="payableDetails.basic_info.payable_no"></div>
                    </el-form-item>
                </el-col>
                <template v-if="payableDetails.basic_info.source_type">
                    <template v-if="payableDetails.basic_info.source_type === 'purchase'">
                        <el-col :span="12">
                            <el-form-item label="供应商名称">
                                <div v-text="payableDetails.detail && payableDetails.detail.supplier_name"></div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="采购编号">
                                <el-link
                                    type="primary"
                                    v-text="payableDetails.detail.purchase_no"
                                    :underline="false"
                                    @click="
                                        handleClickRelateId(
                                            payableDetails.basic_info &&
                                                payableDetails.basic_info.relate_type == 'purchase'
                                                ? payableDetails.basic_info.relate_id
                                                : ''
                                        )
                                    "
                                >
                                </el-link> </el-form-item
                        ></el-col>
                    </template>
                    <template v-else-if="payableDetails.basic_info.source_type === 'order_return'">
                        <el-col :span="12">
                            <el-form-item label="客户公司名称">
                                <el-link
                                    type="primary"
                                    v-text="
                                        payableDetails.detail &&
                                        payableDetails.detail.customer_info &&
                                        payableDetails.detail.customer_info.name
                                    "
                                    :underline="false"
                                    @click="
                                        handleClickCustomerDetail(
                                            payableDetails.detail &&
                                                payableDetails.detail.customer_info &&
                                                payableDetails.detail.customer_info.id,
                                            payableDetails.detail &&
                                                payableDetails.detail.customer_info &&
                                                payableDetails.detail.customer_info.name
                                        )
                                    "
                                >
                                </el-link>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="订单编号">
                                <el-link
                                    type="primary"
                                    v-text="payableDetails.detail.order_no"
                                    :underline="false"
                                    @click="handleClickOrderDetail(payableDetails.detail.order_no)"
                                >
                                </el-link> </el-form-item
                        ></el-col>
                    </template>
                </template>

                <el-col :span="12">
                    <el-form-item label="审批编号">
                        <div v-if="payableDetails.basic_info && payableDetails.basic_info.approval_id">
                            <el-link
                                type="primary"
                                v-text="payableDetails.basic_info.approval_id"
                                :underline="false"
                                @click="handleClickApprovalDetail(payableDetails.basic_info.approval_id)"
                            >
                            </el-link>
                        </div>
                        <div v-else>--</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="申请人">
                        <div
                            v-text="payableDetails.basic_info.uid_info && payableDetails.basic_info.uid_info.name"
                        ></div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="申请时间">
                        <div v-text="payableDetails.basic_info && payableDetails.basic_info.apply_time"></div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="page_little_title">金额信息</div>
        <el-form label-position="top" size="small">
            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="应付金额">
                        <div
                            v-text="
                                Number(payableDetails.basic_info.payable_amount).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })
                            "
                        ></div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="已付金额">
                        <div
                            v-text="
                                Number(payableDetails.basic_info.paid_amount).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })
                            "
                        ></div>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="payableDetails.basic_info">
                    <el-form-item label="取消付款金额" v-if="payableDetails.basic_info.payment_status == 3">
                        <div
                            v-text="
                                Number(payableDetails.basic_info.unpaid_amount).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })
                            "
                        ></div>
                    </el-form-item>
                    <el-form-item label="应付未付金额" v-else>
                        <div>
                            {{
                                Number(payableDetails.basic_info.unpaid_amount).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })
                            }}
                            <span v-if="
                                    (payableDetails.basic_info.payment_status == 1 ||
                                    payableDetails.basic_info.payment_status == 4) && hasOperatePermission
                                " class="link-label" @click="handleClickPayable">去付款</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="page_little_title">收款方信息</div>
        <el-form label-position="top" size="small">
            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="开户名">
                        <div v-text="payableDetails.payee_info.account_name"></div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="开户行">
                        <div v-text="payableDetails.payee_info.bank_name"></div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="开户账号">
                        <div v-text="payableDetails.payee_info.account_number"></div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <!-- 部分支付或全部支付后 -->
        <div v-if="payableDetails.payment_records && payableDetails.payment_records.length > 0">
            <div class="page_little_title">支付记录</div>
            <el-table :data="payableDetails.payment_records" size="small" border class="custom_table">
                <el-table-column label="付款时间" min-width="150" prop="payment_time"></el-table-column>
                <el-table-column align="left" label="支付方式" min-width="100" prop="payment_method">
                    <template slot-scope="{ row }">
                        <span>{{ payTypeList.find((item) => item.value == row.payment_method)?.name || "" }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" label="支付金额" min-width="140" prop="payment_amount">
                    <template slot-scope="{ row }">
                        <span
                            v-text="
                                Number(row.payment_amount).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })
                            "
                        ></span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="left"
                    label="备注"
                    min-width="150"
                    prop="remarks"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column align="left" label="支付凭证" min-width="130" prop="voucher">
                    <template slot-scope="{ row }">
                        <div style="display: flex; align-items: center; justify-content: left" class="table_img_wrap">
                            <el-image
                                :preview-src-list="row.voucher"
                                :src="row.voucher[0]"
                                title="支付凭证"
                                alt=""
                                style="max-width: 32px; max-height: 32px"
                                v-if="row.voucher && row.voucher.length > 0"
                            >
                            </el-image>
                            <el-popover
                                placement="bottom-start"
                                title=""
                                width="248"
                                trigger="click"
                                content=""
                                popper-class="table_img_popover"
                            >
                                <ul class="voucher_list">
                                    <li :key="index" class="voucher_item" v-for="(item, index) in row.voucher">
                                        <el-image
                                            :preview-src-list="row.voucher"
                                            :src="item"
                                            alt=""
                                            style="max-width: 32px; max-height: 32px"
                                        ></el-image>
                                    </li>
                                </ul>
                                <div
                                    slot="reference"
                                    class="table_img_mark"
                                    v-if="row.voucher && row.voucher.length > 1"
                                >
                                    <span>{{ row.voucher.length }}</span>
                                </div>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <p
                class="total_payment mb_24"
                v-html="
                    '支付总金额：' +
                    payableDetails.payment_records.reduce((total, item) => total + Number(item.payment_amount), 0)
                "
            ></p>
        </div>
        <div v-if="payableBatchPayInfo.length > 0">
            <div class="page_little_title">合并支付记录</div>
            <div v-for="(table, index) in payableBatchPayInfo" :key="index">
                <el-table
                    :data="table.data"
                    :key="index"
                    :span-method="(row,column,rowIndex,columnIndex)=>{return arraySpanMethod({row},table.data.length)}"
                    size="small"
                    border
                    class="custom_table"
                >
                    <el-table-column label="应付编号" min-width="158" prop="payable_no" show-overflow-tooltip>
                        <template slot-scope="{ row }">
                            <el-link
                                :underline="false"
                                @click="handleClickPayableDetail(row)"
                                type="primary"
                                v-text="row.payable_no"
                            >
                            </el-link>
                        </template>
                    </el-table-column>
                    <template v-if="payableDetails.basic_info.source_type === 'purchase'">
                        <el-table-column label="供应商名称" min-width="150" show-overflow-tooltip key="1">
                            <template slot-scope="{ row }">
                                <span>{{ row.detail && row.detail.supplier_name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="采购编号" min-width="160" show-overflow-tooltip key="2">
                            <template slot-scope="{ row }">
                                <el-link
                                    :underline="false"
                                    @click="handleClickRelateId(row.relate_id)"
                                    type="primary"
                                    v-text="row.detail && row.detail.purchase_no"
                                >
                                </el-link>
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else-if="payableDetails.basic_info.source_type === 'order_return'">
                        <el-table-column label="客户公司" min-width="150" show-overflow-tooltip key="3">
                            <template slot-scope="{ row }">
                                <span>{{ row.customer_info && row.customer_info.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="订单编号" min-width="140" show-overflow-tooltip key="4">
                            <template slot-scope="{ row }">
                                <el-link
                                    :underline="false"
                                    @click="handleClickOrderDetail(row.detail && row.detail.order_no)"
                                    type="primary"
                                    v-text="row.detail && row.detail.order_no"
                                >
                                </el-link>
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else>
                        <el-table-column prop="payee_name" label="收款方" min-width="150" show-overflow-tooltip key="5">
                            <template slot-scope="{ row }">
                                <span>{{ row.detail && row.detail.payee_name }}</span>
                            </template>
                        </el-table-column>
                    </template>
                    <el-table-column label="审批编号" min-width="100">
                        <template slot-scope="{ row }">
                            <el-link
                                :underline="false"
                                @click="handleClickApprovalDetail(row.approval_id)"
                                type="primary"
                                v-text="row.approval_id"
                                v-if="row.approval_id"
                            >
                            </el-link>
                            <span v-else>--</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" label="申请人" prop="user_name" min-width="140">
                        <template slot-scope="{ row }">
                            <PersonnelCard :userId="row.uid_info.id" v-if="row.uid_info && row.uid_info.id">
                                <template slot="container">
                                    <div class="user-avatar-btn">
                                        <img :src="row.uid_info.avatar ? row.uid_info.avatar : defaultImg" alt="" />
                                        <span>{{ row.uid_info.name }}</span>
                                    </div>
                                </template>
                            </PersonnelCard>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" label="应付金额" prop="payable_amount" min-width="116">
                        <template slot-scope="{ row }">
                            <span
                                v-text="
                                    Number(row.payable_amount).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })
                                "
                            ></span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" label="应付未付金额" prop="unpaid_amount" min-width="116">
                        <template slot-scope="{ row }">
                            <span
                                v-text="
                                    Number(row.unpaid_amount).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })
                                "
                            ></span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" label="支付金额" prop="payment_amount" min-width="116">
                        <template slot-scope="{ row }">
                            <span
                                v-text="
                                    Number(row.payment_amount).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })
                                "
                            ></span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" label="备注" min-width="150" prop="remarks" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column align="left" label="支付凭证" min-width="150" prop="voucher">
                        <template slot-scope="{ row }">
                            <div
                                style="display: flex; align-items: center; justify-content: left"
                                class="table_img_wrap"
                            >
                                <el-image
                                    :preview-src-list="row.voucher"
                                    :src="row.voucher[0]"
                                    title="支付凭证"
                                    alt=""
                                    style="max-width: 32px; max-height: 32px"
                                    v-if="row.voucher && row.voucher.length > 0"
                                >
                                </el-image>
                                <el-popover
                                    placement="bottom-start"
                                    title=""
                                    width="248"
                                    trigger="click"
                                    content=""
                                    popper-class="table_img_popover"
                                >
                                    <ul class="voucher_list">
                                        <li :key="index" class="voucher_item" v-for="(item, index) in row.voucher">
                                            <el-image
                                                :preview-src-list="row.voucher"
                                                :src="item"
                                                alt=""
                                                style="max-width: 32px; max-height: 32px"
                                            ></el-image>
                                        </li>
                                    </ul>
                                    <div
                                        slot="reference"
                                        class="table_img_mark"
                                        v-if="row.voucher && row.voucher.length > 1"
                                    >
                                        <span>{{ row.voucher.length }}</span>
                                    </div>
                                </el-popover>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="total_payment mb_24">
                    <span
                        >应付未付总金额：{{
                            table.data.reduce((total, item) => total + Number(item.unpaid_amount), 0).toFixed(2)
                        }}</span
                    >
                    <span
                        >支付总金额：{{
                            table.data.reduce((total, item) => total + Number(item.payment_amount), 0).toFixed(2)
                        }}</span
                    >
                </div>
            </div>
        </div>
        <div v-if="payableDetails.basic_info && payableDetails.basic_info.payment_status == 3">
            <div class="page_little_title">取消信息</div>
            <el-form label-position="top" size="small">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="取消时间">
                            <div v-text="payableDetails.cancel_info.cancel_time"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="取消原因">
                            <div v-text="payableDetails.cancel_info.cancel_remarks"></div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <PurchaseDetail
            :purchaseDetailVisible.sync="purchaseDetailVisible"
            v-if="purchaseDetailVisible"
            :purchaseId="purchaseId"
        />
        <!-- 付款 -->
        <PayableDetailPaymentDialog
            v-if="payablePaymentDialog"
            :payablePaymentDialog.sync="payablePaymentDialog"
            :payable_no="payable_no"
            :type="payablePaymentType"
            :payable_type="payableDetails.basic_info && payableDetails.basic_info.source_type"
            @paymentSuccess="handleClickSearch"
        />
    </el-dialog>
</template>
<script>
import { PayableDetail, PayableMergedPaymentRecords } from "@/api";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
import PurchaseDetail from "../../../Purchase/component/purchase_detail.vue";
import PayableDetailPaymentDialog from "./payable_payment.vue";
import {mapGetters} from "vuex";

export default {
    name: "PayableDetails",
    props: {
        payableDetailsDialogVisible: {
            type: Boolean,
            default: false,
        },
        payable_no: {
            type: String,
            default: "",
        }, // 应付编号
    },
    components: { PersonnelCard, PurchaseDetail , PayableDetailPaymentDialog},
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            payableDetails: {
                basic_info: {}, // 基础信息
                cancel_info: {},
                payee_info: {}, //收款方信息
                payment_records: [], //付款记录
                detail: {}, // 差异字段
            },
            payableBatchPayInfo: [],
            batchRowArray: {}, // 记录合并行
            payTypeList: [
                { name: "电汇", value: 1 },
                { name: "微信", value: 2 },
                { name: "支付宝", value: 3 },
                { name: "现金", value: 4 },
                { name: "银行承兑", value: 5 },
                { name: "商业承兑", value: 6 },
                { name: "支票", value: 7 },
            ],

            // 采购详情
            purchaseDetailVisible: false,
            purchaseId: "",

            // 付款
            payablePaymentDialog: false,
            payablePaymentType: "payment",
        };
    },
    computed: {
        ...mapGetters(['hasPermission']),
        // 操作权限，付款、确认、取消、驳回、作废等操作
        hasOperatePermission() {
            return this.hasPermission('finance.payable.payment.add', 'finance', 'PayableManage');
        },
    },
    created() {
        if (this.payable_no) {
            this.getPayableDetail();
            this.getPayableMergedPaymentRecords();
        }
    },
    methods: {
        handleDetailDialogClose() {
            this.$emit("update:payableDetailsDialogVisible", false);
        },
        arraySpanMethod(data,length) {
            let { row, column, rowIndex, columnIndex } = data.row
            if (columnIndex === 8 || columnIndex === 9) {
                if (rowIndex === 0) {
                    return [length, 1]; // 合并所有行
                } else {
                    return [0, 0]; // 其他行不显示
                }
            }
        },
        // 应付详情
        getPayableDetail() {
            PayableDetail({ payable_no: this.payable_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.payableDetails = data;
                }
            });
        },
        // 批量支付记录
        getPayableMergedPaymentRecords() {
            PayableMergedPaymentRecords({ payable_no: this.payable_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || [];

                    var mergedPaymentData = [];
                    data.forEach((item) => {
                        if (item.payable_list.length) {
                            let payable_list = item.payable_list.map((payableItem) => ({
                                ...payableItem,
                                remarks: item.remarks,
                                voucher: item.voucher,
                            }));
                            payable_list[0].totalLen = item.payable_list.length;
                            mergedPaymentData.push({
                                payment_batch_no: item.payment_batch_no,
                                data: payable_list,
                            });
                        }
                    });
                    this.payableBatchPayInfo = mergedPaymentData;
                }
            });
        },
        handleClickPayableDetail(row) {
            this.$emit("handleAgainLookDetail", row)  
        },
        // 采购详情
        handleClickRelateId(purchaseId) {
            this.purchaseId = purchaseId;
            this.purchaseDetailVisible = true;
        },
        // 审批详情
        handleClickApprovalDetail(approval_id) {
            this.$showApprovalDetail({
                approval_id,
            }).then((res) => {});
        },
        // 查看客户详情
        handleClickCustomerDetail(customer_id, customer_name) {
            this.$emit("handleClosePaymentDialog")
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id,
                    name: customer_name,
                },
            });
        },
        // 查看订单详情
        handleClickOrderDetail(order_no) {
            this.$emit("handleClosePaymentDialog")
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: order_no,
                    name: order_no,
                    query_type: "order_no",
                },
            });
        },
        // 去付款
        handleClickPayable() {
            // this.payablePaymentType = "payment";
            // this.payablePaymentDialog = true;
            const row = {
                payable_no: this.payable_no
            }
            this.$emit("handleDetailToPayment", row)
        },
        handleClickSearch() {
            this.getPayableDetail();
            this.getPayableMergedPaymentRecords();
        }
    },
};
</script>
<style lang="scss">
.mb_24 {
    margin-bottom: 24px;
}

.custom-payable-detail_dialog {
    .page_little_title {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
    }

    .el-dialog__body {
        max-height: 660px;
        overflow-y: auto;
    }

    .el-form {
        .el-form-item__label {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(153, 153, 153, 1);
        }

        .el-form-item__content {
            min-height: 22px;
            line-height: 22px;
        }
    }

    .total_payment {
        width: 100%;
        padding: 8px 12px;
        border-radius: 6px 6px, 0px, 0px;
        background: rgba(237, 240, 244, 1);

        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);
            margin-right: 24px;
        }
    }
    .el-form {
        .el-row {
            .el-link--primary {
                display: block;
            }
        }
    }
}

.table_img_popover {
    padding: 8px;

    .voucher_list {
        display: flex;
        gap: 8px;

        .voucher_item {
            width: 32px;
            height: 32px;
            cursor: pointer;
            position: relative;
            text-align: center;
            line-height: 32px;
            border-radius: 4px;

            .el-image {
                max-width: 100%;
                max-height: 100%;
            }

            img {
                max-width: 100%;
                max-height: 100%;
                object-fit: cover;
            }
        }
    }
}

.table_img_wrap {
    position: relative;
    width: 32px;
    height: 32px;
    border-radius: 4px;

    .table_img_mark {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 32px;
        border-radius: 4px;
        background: rgba(0, 0, 0, 0.6);
        cursor: pointer;

        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(255, 255, 255, 1);
        }
    }
}
</style>
